var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagingIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52382 20.9287C5.14151 21.3727 4.65903 21.933 4.06652 22.7104C3.81953 23.1612 4.31724 24.3572 4.63016 24.4008C6.42267 24.6506 7.6999 24.4759 8.94237 24.306H8.94239C9.87358 24.1787 10.7852 24.054 11.8797 24.1126C16.509 26.2096 22.064 24.4914 24.6584 19.9992C27.4202 15.217 25.7812 9.10216 20.9976 6.34119C16.214 3.58023 10.0972 5.21871 7.3354 10.0008C5.74679 12.7515 5.61423 15.9432 6.69867 18.6839C6.69998 18.9659 6.66361 19.2004 6.5863 19.4205C6.42358 19.8837 6.07951 20.2833 5.52382 20.9287Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIconSelected);
export default __webpack_public_path__ + "static/media/messaging-icon-selected.8079b0a59ac38abe1f27983a72312773.svg";
export { ForwardRef as ReactComponent };